import React from "react";
import {PrimaryCollapsibleSection} from "../../../../../elements/collapsableSection/primary/PrimaryCollapsibleSection";
import {CardField, SignPosition} from "./components/CardField";
import {ReturnedFinanceQuoteChatEventDTO} from "../../../../../../api/generated";
import {getFinanceProviderTitle} from "../../../../../../utils/enumValueTitleUtil";

interface FinanceQuotationChatEventCardProps {
    returnedFinanceQuoteChatEvent: ReturnedFinanceQuoteChatEventDTO
}

export const FinanceQuotationChatEventCard: React.FC<FinanceQuotationChatEventCardProps> = ({
                                                                                                returnedFinanceQuoteChatEvent
                                                                                            }) => {
    const hasPcpIllustrationFields = !!(
        returnedFinanceQuoteChatEvent.pcp_apr ||
        returnedFinanceQuoteChatEvent.pcp_residual_percentage ||
        returnedFinanceQuoteChatEvent.pcp_dealer_contribution ||
        returnedFinanceQuoteChatEvent.pcp_balloon_payment ||
        returnedFinanceQuoteChatEvent.pcp_total_payable_buy ||
        returnedFinanceQuoteChatEvent.pcp_total_payable_return ||
        returnedFinanceQuoteChatEvent.pcp_interest_paid_buy ||
        returnedFinanceQuoteChatEvent.reason_for_pcp_refusal
    )

    const financeProvider = returnedFinanceQuoteChatEvent.finance_provider;

    return <PrimaryCollapsibleSection title={"Finance Quotation"}>
        <CardField title="Finance Provider"
                   value={financeProvider ? getFinanceProviderTitle(financeProvider) : undefined}
        />
        <CardField title="Finance Type"
                   value={returnedFinanceQuoteChatEvent.finance_type}
                   />
        <CardField
            title="Vehicle Price"
            value={returnedFinanceQuoteChatEvent.full_vehicle_price}
            sign={"£"}
            signPosition={SignPosition.START}
        />
        <CardField
            title="Total Deposit"
            value={returnedFinanceQuoteChatEvent.total_deposit}
            sign={"£"}
            signPosition={SignPosition.START}
        />
        <CardField
            title="Total Amount Payable"
            value={returnedFinanceQuoteChatEvent.total_amount_payable}
            sign={"£"}
            signPosition={SignPosition.START}
        />
        <CardField
            title="Term"
            value={returnedFinanceQuoteChatEvent.finance_term}
            sign={" month(s)"}
        />
        <CardField
            title="APR"
            value={returnedFinanceQuoteChatEvent.apr}
            sign={"%"}
        />
        <CardField
            title="Fixed Interest Rate"
            value={returnedFinanceQuoteChatEvent.interest_rate}
            sign={"%"}
        />
        <CardField
            title="Monthly Payment"
            value={returnedFinanceQuoteChatEvent.monthly_payment}
            sign={"£"}
            signPosition={SignPosition.START}
        />
        {hasPcpIllustrationFields && <>
            <CardField
                title="PCP Dealer Contribution"
                value={returnedFinanceQuoteChatEvent.pcp_dealer_contribution}
                sign={"£"}
                signPosition={SignPosition.START}
            />
            <CardField
                title="PCP Residual Percentage"
                value={returnedFinanceQuoteChatEvent.pcp_residual_percentage}
                sign={"%"}
            />
            <CardField
                title="Optional Final Payment"
                value={returnedFinanceQuoteChatEvent.pcp_balloon_payment}
                sign={"£"}
                signPosition={SignPosition.START}
            />
            <CardField
                title="Total Payable If Bought"
                value={returnedFinanceQuoteChatEvent.pcp_total_payable_buy}
                sign={"£"}
                signPosition={SignPosition.START}
            />
            <CardField
                title="Total Payable If Returned"
                value={returnedFinanceQuoteChatEvent.pcp_total_payable_return}
                sign={"£"}
                signPosition={SignPosition.START}
            />
            <CardField
                title="Interest Paid If Bought"
                value={returnedFinanceQuoteChatEvent.pcp_interest_paid_buy}
                sign={"£"}
                signPosition={SignPosition.START}
            />
            <CardField
                title="Reason For PCP Refusal"
                value={returnedFinanceQuoteChatEvent.reason_for_pcp_refusal}
            />
        </>}
    </PrimaryCollapsibleSection>
}
